<template>
  <div class="dramaPC zy_constr">
    <div class="dramaPC-info">
      <div class="dramaPC-title">运营矩阵</div>
      <div class="dramaPC-content">
        <div class="dramaPC-desc">
          围绕年轻用户多元化的内容消费需求，公司持续拓展短剧内容分发与运营渠道，逐步推广自有短剧APP平台，与小程序短剧构成互补格局，支撑短剧业务的深度拓展。
        </div>
        <div class="dramaPC-desc">
          公司旗下主要短剧产品包括速看短剧APP等自有产品，子诗短剧、薏米短剧等小程序，早茶剧场、青柠剧场、立看短剧、阿有剧场、冰橙剧场等多部抖音号。
        </div>
      </div>
      <img
        class="dramaPC-bg"
        v-lazy="
          'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/ffc1a667-7e22-4b3a-a42c-6a21cafba5fe.png'
        "
        alt=""
      />
    </div>
    <img
      class="dramaPC-img"
      v-lazy="
        'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/0b60b779-7f98-41b4-9b44-239de7da475d.png'
      "
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: 'DramaPC',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.dramaPC-info {
  box-sizing: border-box;
  height: 312px;
  background-color: #f8f8fa;
  position: relative;
  border-radius: 16px;
  padding: 64px 497px 0 48px;
}

.dramaPC-bg {
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
  height: 100%;
}

.dramaPC-title {
  font-size: 24px;
  font-weight: 500;
  color: #000;
  line-height: 36px;
}

.dramaPC-content {
  margin-top: 24px;
}

.dramaPC-desc {
  margin-top: 12px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
  &:first-child {
    margin-top: 0;
  }
}

.dramaPC-img {
  display: block;
  width: 100%;
  height: 360px;
  margin-top: 48px;
}
</style>
